<template>
  <div class="md-layout">
    <el-date-picker
      v-model="date"
      type="date"
      placeholder="Choose a Date"
      :disabled="readOnly">
    </el-date-picker>
  </div>
</template>

<script>
import { DatePicker } from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

// language configuration
locale.use(lang);

export default {
  name: 'form-template-date-question',
  components: {
    [DatePicker.name]: DatePicker,
  },
  props: {
    question: Object,
    readOnly: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      date: null,
    };
  },
  watch: {
  },
  computed: {
  },
  created() {
  },
  mounted() {
    // On mounted
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.text-area {
  border: 1px solid #bcc6cc;
  padding: 15px;
  width: 100%;
  min-height: 0px;
  height: auto;
}
.field:after {
  border-style: none!important;
}
</style>
